import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { BuscarExpedienteParams, BuscarExpedienteResponse } from '../../interfaces/comun/ExpedienteInterface';

export const BuscarExpediente = ( params : BuscarExpedienteParams ) => {

    return new Promise<BuscarExpedienteResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );
        
        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Expediente/BuscarExpediente', params,  token)
            .then( ({ data } : { data : BuscarExpedienteResponse } ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({ 
                    success: false, 
                    message: error.message, 
                    idExpediente: 0, 
                    idJuez: 0, 
                    juez: '', 
                    numeroExpediente: '', 
                });
            });
        }

    });

}